import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'components/PageLayout';
import { usePlaces } from 'features/places/hooks/usePlaces';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { EmptyPlaces } from './EmptyPlaces';
import { SavedPlaces } from './SavedPlaces';

const Content = (): JSX.Element => {
  const { t } = useTranslation();
  const { places } = usePlaces({ sync: true });

  return (
    <>
      <Helmet>
        <title>{t('places.title')}</title>
      </Helmet>
      <SimplePageLayout maxWidth="xs">
        {places.length > 0 ? <SavedPlaces /> : <EmptyPlaces />}
      </SimplePageLayout>
    </>
  );
};

export const Places = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="PlacesPage"
      headerBarProps={{ title: t('places.title'), action: '/' }}
    >
      <Content />
    </PageLayout>
  );
};
